import { render, staticRenderFns } from "./TitleDetail.vue?vue&type=template&id=3a1cceed&scoped=true"
import script from "./TitleDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetail.vue?vue&type=style&index=0&id=3a1cceed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1cceed",
  null
  
)

export default component.exports